import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Guards the OperixAI control plane. Company users (incl. Company Super Admins)
// cannot reach /platform — only global Platform Admins (operix_admin).
export default function PlatformRoute({ children }) {
  const { user, isPlatformAdmin } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400" data-testid="platform-loading">
        Loading…
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (!isPlatformAdmin) return <Navigate to="/" replace />;
  return children;
}
